import { module } from 'modujs'
import { gsap } from '../gsap'
import lottie from 'lottie-web'
import { CUSTOM_EVENT } from '../config'

export default class Header extends module {

    static get settings() {
        return {
            CLASS_REDUCED: 'is-reduced',
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        this.$name = this.$('name')[0]
        this.$areasOpener = this.$('areasOpener')[0]
        this.$menuOpener = this.$('menuOpener')[0]
        this.$icon = this.$('icon')[0]
        this.$menuToggler = this.$('menuToggler')[0]

        // Vars
        this.isOpen = false
        this.isReduced = false
        this.reduceIsLocked = false

        // Events
        this.events = {
            click: {
                'overlay': 'close',
                'menuOpener': 'openMenu',
                'menuToggler': 'toggleMenu',
                'areasOpener': 'openAreas',
            },
        }
    }

    init() {
        this.iconAnimation = lottie.loadAnimation({
            container: this.$icon,
            path: '/assets/lottie/icon.json',
            renderer: 'svg',
            loop: true,
            autoplay: false,
        })

        gsap.set(this.$icon, { opacity: 0})

        window.addEventListener(CUSTOM_EVENT.READY, this.onReady = () => {
            this.iconAnimation.play()
            gsap.to(this.$icon, {
                opacity: 1,
                duration: 0.2,
                ease: 'power2.out',
                delay: 1,
            })
        })
    }

    openMenu() {
        this.call('open', null, 'ModalMenu')
    }

    onMenuOpen() {
        this.$menuToggler.setAttribute('aria-label', 'Close main menu')
        this.$name.setAttribute('tabindex', '-1')
        this.$areasOpener.setAttribute('tabindex', '-1')
        this.$menuOpener.setAttribute('tabindex', '-1')
        this.lockReduced()
    }

    onMenuClose() {
        this.$menuToggler.setAttribute('aria-label', 'Open main menu')
        this.$name.removeAttribute('tabindex')
        this.$areasOpener.removeAttribute('tabindex')
        this.$menuOpener.removeAttribute('tabindex')
        this.unlockReduced()
    }

    toggleMenu() {
        this.call('toggle', null, 'ModalMenu')
    }

    openAreas() {
        this.call('open', null, 'ModalAreas')
        this.lockReduced()
    }

    setReduced(reduced = true) {
        if (this.reduceIsLocked || this.isReduced === reduced) {
            return
        }

        this.$el.classList.toggle(Header.settings.CLASS_REDUCED, reduced)
        this.isReduced = reduced
    }

    lockReduced(reduced=false) {
        this.setReduced(reduced)
        this.reduceIsLocked = true
    }

    unlockReduced() {
        this.reduceIsLocked = false
    }

    destroy() {
        window.removeEventListener(CUSTOM_EVENT.READY, this.onReady)
    }
}
